/**
 * shop-cart (React) — design hérité de shop-cart.css / shop-forms.css (classes
 * .gas-shop-* réutilisées à l'identique). On coupe les animations Radix du
 * dialog de confirmation (useGasConfirm).
 */
.gas-react-dialog__overlay,
.gas-react-dialog__content,
.gas-react-dialog__content *,
[data-radix-popper-content-wrapper],
[data-radix-popper-content-wrapper] *,
[data-radix-portal],
[data-radix-portal] * {
    animation: none !important;
    animation-duration: 0s !important;
    animation-delay: 0s !important;
    transition: none !important;
    transition-duration: 0s !important;
    transition-delay: 0s !important;
}
